import { withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindow, BrowserWindowSymbol, IAppWillUnmountHandler } from '@wix/thunderbolt-symbols'
import type { IWindowMessageRegistrar, WindowMessageConsumer } from '../types'

export const DsWindowMessageRegistrar = withDependencies(
	[BrowserWindowSymbol],
	(window: NonNullable<BrowserWindow>): IWindowMessageRegistrar & IAppWillUnmountHandler => {
		const messageHandlers: Array<WindowMessageConsumer> = []

		const handleMessage = (evt: MessageEventInit) => {
			const event = { source: evt.source, data: evt.data, origin: evt.origin }
			const handler = messageHandlers.find((h) => h.canHandleEvent(event))
			handler?.handleEvent(event)
		}

		window.addEventListener('message', handleMessage)

		return {
			addWindowMessageHandler(handler: WindowMessageConsumer) {
				messageHandlers.push(handler)
			},
			appWillUnmount() {
				window.removeEventListener('message', handleMessage)
			},
		}
	}
)
